import pluralize from 'pluralize'

import { Typography } from '@/shared'

interface Props {
    count: number
}

export const CustomersHeader = ({ count }: Props) => {
    return (
        <div className="space-y-1">
            <Typography variant="h3">Customers</Typography>

            <Typography variant="subtitle">
                {count ? `${count} new ${pluralize('customer', count)} in this year` : 'No new customers in this year'}
            </Typography>
        </div>
    )
}
